import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}

const actions = {
    // 获取ModelEasy环境列表
    getMeEnvironmentList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['instance:env:details:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/instanceEnvDetails`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },
}

export default {
    state,
    actions
}
